import { useCallback, useState } from 'react';

export const useCalendarDisplaySettings = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openChangeHandler = useCallback((nextIsOpen: boolean) => {
    setIsOpen(nextIsOpen);
  }, []);

  return {
    isOpen,
    openChangeHandler,
  };
};
